import { useMenu } from '../menuController';

/**
 * Este aside aparece en la vista twoColumnList en los
 * breakpoints de vista móvil.
 */

export const AccordionAside = () => {
  const children = useMenu([1, 2, 3]);
  return children;
};
